import { render, staticRenderFns } from "./AccrualsBrandLoader.vue?vue&type=template&id=3d208544&scoped=true"
import script from "./AccrualsBrandLoader.vue?vue&type=script&lang=js"
export * from "./AccrualsBrandLoader.vue?vue&type=script&lang=js"
import style0 from "./AccrualsBrandLoader.vue?vue&type=style&index=0&id=3d208544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d208544",
  null
  
)

export default component.exports